import { render } from "./AlzataSortIndicator.vue?vue&type=template&id=6a5a917d"
import script from "./AlzataSortIndicator.vue?vue&type=script&lang=js"
export * from "./AlzataSortIndicator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__